var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.54255L10.1681 3.82979C12.6 4.4234 14.3809 6.64468 14.3809 9.11489V15.2043L14.8213 15.6447L15.4149 16.2574H2.58511L3.17872 15.6447L3.61915 15.2043V9.11489C3.61915 6.64468 5.38085 4.40426 7.83192 3.82979L9 3.54255ZM9 0C8.11915 0 7.46809 0.72766 7.46809 1.62766V2.35532C4.4234 3.06383 2.08723 5.82128 2.08723 9.11489V14.5915L0 16.7362V17.8085H18V16.7362L15.9128 14.5915V9.11489C15.9128 5.82128 13.5766 3.06383 10.5319 2.33617V1.64681C10.5319 0.880851 10.1106 0.191489 9.38298 0.0382978C9.24894 -3.70944e-08 9.11489 0 9 0ZM11.1064 19.3404H6.89362C6.89362 20.5277 7.81277 21.4468 9 21.4468C10.1872 21.4468 11.1064 20.5277 11.1064 19.3404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.2a567194502419adb6151797f6e0c671.svg";
export { ForwardRef as ReactComponent };